import React from "react";
import { NavLink } from "react-router-dom";

import {
    CAvatar,
    CContainer,
    CHeader,
    CHeaderBrand,
    CHeaderNav,
    CNavItem,
    CDropdown,
    CDropdownToggle,
    CDropdownMenu,
} from "@coreui/react";
import { t } from "../i18n";

export default function Navbar({ user }) {
    const csrfToken = document
        .querySelector('meta[name="csrf-token"]')
        ?.getAttribute("content");

    const linkClass = ({ isActive }) =>
        `nav-link ${isActive ? "active fw-semibold" : ""}`;

    const initials = user.displayName.toUpperCase();

    return (
        <CHeader className="border-bottom bg-white shadow-sm">
            <CContainer fluid className="px-4">
                <CHeaderBrand as={NavLink} to="/dashboard" className="fw-bold fs-4">
                    💰Finansai
                </CHeaderBrand>

                <CHeaderNav className="me-auto ms-5">
                    <CNavItem>
                        <NavLink to="/expenses" className={linkClass}>
                            {t("nav.expenses")}
                        </NavLink>
                    </CNavItem>

                    <CNavItem>
                        <NavLink to="/reports" className={linkClass}>
                            {t("nav.reports")}
                        </NavLink>
                    </CNavItem>
                </CHeaderNav>

                <CDropdown alignment="end">
                    <CDropdownToggle color="light" className="d-flex align-items-center gap-2">
                        <CAvatar src={user.avatarUrl || undefined} color="primary" size="md">
                            {!user.avatarUrl && initials}
                        </CAvatar>

                        <span>{user.displayName}</span>
                    </CDropdownToggle>

                    <CDropdownMenu>
                        <form method="post" action="/users/sign_out">
                            <input type="hidden" name="_method" value="delete" />
                            <input type="hidden" name="authenticity_token" value={csrfToken} />

                            <button type="submit" className="dropdown-item text-danger">
                                {t("nav.logout")}
                            </button>
                        </form>
                    </CDropdownMenu>
                </CDropdown>
            </CContainer>
        </CHeader>
    );
}
